import ChunkErrorBoundary from './ChunkErrorBoundary';

export { ChunkErrorBoundary };
export default ChunkErrorBoundary;
